<template>
    <PdfApp :style="{ height: height + 'px' }" :pdf="base64ToArrayBuffer(pdfFile)" theme="light" :fileName="pdfFileName"
        :config="config" />
</template>

<script setup>
//import { onMounted, ref } from 'vue';
import PdfApp from "vue3-pdf-app";
import "vue3-pdf-app/dist/icons/main.css";
//import { getAtestado } from '@/services/sde/atestado.service';

defineProps({
    pdfFileName: {
        type: String,
        required: true,
        default: "Nome do PDF"
    },
    pdfFile: {
        type: String,
        required: true,
        default: ""
    },
    height: {
        type: Number,
        default: 600
    }
});

//const pdfBuffer = ref(null);
const config = {
    toolbar: {
        toolbarViewerLeft: {
            findbar: false,
            previous: true,
            next: true,
            pageNumber: true,
        },
        toolbarViewerRight: {
            presentationMode: false,
            openFile: false,
            print: true,
            download: true,
            viewBookmark: false,
        }
    }
}

//onMounted(async () => {
//console.log('onMounted PDF');
//const ret = await getAtestado(1);
//pdfBuffer.value = base64ToArrayBuffer(ret.data);
//});

const base64ToArrayBuffer = (base64) => {
    var binaryString = atob(base64);
    var bytes = new Uint8Array(binaryString.length);
    for (var i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}

</script>
